import { useCallback } from "react"

import { useDevAuth as useAuth } from "@/hooks/use-dev-auth"

import { useBookId } from "../use-book-id"
import { ApiContext } from "./base"

function getDevSessionToken(): string | null {
  if (process.env.NODE_ENV !== "development") return null
  if (typeof document === "undefined") return null
  const match = document.cookie.match(/(?:^|;\s*)dev_session_token=([^;]+)/)
  return match ? match[1] : null
}

type GetToken = (options?: { skipCache?: boolean }) => Promise<string | null>

export const useApiContext = (bookIdOverride?: string) => {
  const { getToken } = useAuth()
  const urlBookId = useBookId()
  const bookId = bookIdOverride ?? urlBookId

  const getContext = useCallback(async (): Promise<ApiContext> => {
    const devToken = getDevSessionToken()
    const token = (devToken || (await getToken())) ?? undefined
    return {
      token,
      bookId,
      refreshToken: async () => getDevSessionToken() || (await (getToken as GetToken)({ skipCache: true })) || null,
    }
  }, [bookId, getToken])

  return getContext
}
